/*
 * IMPORTS
 */

import React from 'react' // Npm: react.js library.
import { Flex } from '@chakra-ui/react' // Npm: Chakra UI components.


/*
 * PACKAGES
 */
import PlatformSetting from 'components/PlatformSetting'
import GeneralSmtpConfiguration from 'components/GeneralSmtpConfiguration'
import InvoiceSmtpConfiguration from 'components/InvoiceSmtpConfiguration'
import RateSmtpConfiguration from 'components/RateSmtpConfiguration'
import ImapConfiguration from 'components/ImapConfiguration'
import SmppSetting from 'pages/SmppSetting'



/*
 * OBJECTS
 */
const Index = () => {
  // Hook assignment.
  const [forceReRender, setForceReRender] = React.useState(void 0)

  // Return component.
  return (
    <Flex flexDir='column' w='100%' gap='22px' borderRadius='22px' pb='22px'>
      <Flex w='100%' gap='22px' flexDir={{ 'base': 'column', 'md': 'row' }}>
        <Flex flexDir='column' w={{ 'base': '100%', 'md': '30%' }} h='100%'>
          <SmppSetting
            title='SMPP Server Log Level'
          />
        </Flex>
        <Flex flexDir='column' w={{ 'base': '100%', 'md': '30%' }} h='100%' gap='22px'>
          <PlatformSetting key={forceReRender} />
        </Flex>
      </Flex>
      <Flex w='100%' flexDir={{ 'base': 'column', 'md': 'row' }} gap='22px'>
        <Flex
          fontSize={['Clamp(13px, 1.5vw, 15px)']}
          direction={{ base: 'column', md: 'row' }}
          display='flex'
          overflowX="auto"
          h='100%'
          gap="22px"
          w='100%'>
          <Flex w={{ base: '100%', md: '25%' }}>
            <GeneralSmtpConfiguration key={forceReRender} />
          </Flex>
          <Flex w={{ base: '100%', md: '25%' }}>
            <RateSmtpConfiguration key={forceReRender} />
          </Flex>
          <Flex w={{ base: '100%', md: '25%' }}>
            <ImapConfiguration key={forceReRender} />
          </Flex>
          <Flex w={{ base: '100%', md: '25%' }}>
            <InvoiceSmtpConfiguration key={forceReRender} />
          </Flex>
        </Flex>


      </Flex>
    </Flex>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {}


/*
 * EXPORT
 */
export default Index
